// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productTextBadgesStyles } from "@werner/Overrides/Components/ProductTextBadges";
import { css } from "styled-components";

productTextBadgesStyles.badgeText = {
    weight: 400,
    size: 10,
    lineHeight: "12px",
    css: css`
        text-transform: uppercase;
        letter-spacing: 0.55px;
    `,
};

productTextBadgesStyles.textBadgeWrapperStyles = {
    css: css`
        min-height: 18px;
        min-width: 86px;
        width: fit-content;
        line-height: 18px;
        padding: 0;
    `,
};
